/**
 * Applies one cumulative speech result synchronously through the editor adapter.
 *
 * The caller owns the applied-transcript marker, initially `''`, and stores the
 * returned marker after editor callbacks finish. Inactivity resets it even when
 * the adapter is unavailable. An unavailable or rejecting adapter, empty result,
 * or repeated result leaves an active session's marker unchanged. Editor focus
 * and takeover remain caller-owned.
 *
 * @returns The next source-transcript marker, without editor-specific trimming.
 */
export function applyDictationTranscript({ adapter, appliedTranscript, isTranscribing, transcription, }) {
    if (!isTranscribing)
        return '';
    if (!adapter || !transcription || transcription === appliedTranscript)
        return appliedTranscript;
    const result = transcription.startsWith(appliedTranscript)
        ? adapter.append(transcription.slice(appliedTranscript.length), !appliedTranscript)
        : adapter.replace(transcription, appliedTranscript);
    return result !== false ? transcription : appliedTranscript;
}
//# sourceMappingURL=applyDictationTranscript.js.map